const CATEGORIES_ACTIONS_TYPES = {
  SET_CATEGORIES_START: 'SET_CATEGORIES_START',
  SET_CATEGORIES_SUCCESS: 'SET_CATEGORIES_SUCCESS',
  SET_CATEGORIES_FAILURE: 'SET_CATEGORIES_FAILURE',
}

export default CATEGORIES_ACTIONS_TYPES
